import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
const win: any = window;

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: "auto",
    },
    container: {
      [theme.breakpoints.down("xs")]: {
        marginLeft: theme.spacing(0),
        padding: theme.spacing(2),
      },
    },
    rowContainer: {
      flexWrap: "nowrap",
      width: "40%",
      gap: 15,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        flexDirection: "column",
      },
    },
    pageTitle: {
      fontFamily: win["lang"] === "ar" ? "ExpoArabic-Bold;" : "ScandiaWeb-Bold",
      [theme.breakpoints.down("sm")]: {
        fontSize: theme.spacing(3),
      },
    },
    item: {
      width: "100%",
      "& .MuiFormLabel-root": {
        color: "black",
      },
      // '& #file-upload-button': {
      //     display: 'none !important',
      // },
      "& input[type='file']": {
        color: "transparent",
        // display: 'none !important',
      },
      [theme.breakpoints.down("sm")]: {
        flex: 12,
        width: "100% !important",
      },
    },
    bigTextField: {
      fontFamily: win["lang"] === "ar" ? "ExpoArabic-Bold;" : "ScandiaWeb-Bold",
      hieght: theme.spacing(6),
      "& .MuiInput-underline:after": {
        borderWidth: 0,
      },
      "& .MuiInput-underline:before": {
        borderWidth: 0,
      },
      "& .MuiInputBase-inputMultiline": {
        // margin: theme.spacing(1),
        lineHeight: "normal",

        height: "auto",
        width: "100%",
        fontSize: theme.spacing(5),
        fontFamily:
          win["lang"] === "ar" ? "ExpoArabic-Bold;" : "ScandiaWeb-Bold",
        color: "black",
        caretColor: "#008CFF",
      },
    },
    input: {
      width: "100%",
      fontSize: theme.spacing(1),
      "& .MuiInput-underline:after": {
        borderColor: "#D5D8DF",
      },
      "& .MuiInput-underline:before": {
        borderColor: "#D5D8DF",
      },
    },
    steps: {
      fontWeight: 400,
      fontSize: theme.spacing(1),
    },
    button: {
      marginTop: theme.spacing(4),
      marginLeft: 0,
      borderRadius: "40px !important",
      justifyContent: "space-between",
      height: 40,
      fontWeight: 700,
      fontStyle: "normal",
      fontSize: theme.spacing(1.5),
      letterSpacing: "0.8px",
      [theme.breakpoints.down("sm")]: {
        flex: 12,
        width: "100%",
      },
    },
    buttonSuccess: {
      backgroundColor: green[500],
      "&:hover": {
        backgroundColor: green[700],
      },
    },
    buttonProgress: {
      color: green[500],
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
    },
  })
);
